import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "diamond",
  "use": "diamond-usage",
  "viewBox": "0 0 32 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 28\" id=\"diamond\"><path fill=\"currentColor\" d=\"M3.313 12l9.734 10.391L8.359 12H3.312zM16 24.063L21.453 12H10.547zM8.406 10l3.187-6H7.499l-4.5 6h5.406zm10.547 12.391L28.687 12H23.64zM10.672 10h10.656l-3.187-6H13.86zm12.922 0H29l-4.5-6h-4.094zm2.203-7.594l6 8a.993.993 0 01-.063 1.281l-15 16c-.187.203-.453.313-.734.313s-.547-.109-.734-.313l-15-16a.996.996 0 01-.063-1.281l6-8A.962.962 0 017 2h18c.313 0 .609.141.797.406z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol